import { render } from "./ModalUpdatePassword.vue?vue&type=template&id=6de09185&scoped=true"
import script from "./ModalUpdatePassword.vue?vue&type=script&lang=js"
export * from "./ModalUpdatePassword.vue?vue&type=script&lang=js"

import "./ModalUpdatePassword.vue?vue&type=style&index=0&id=6de09185&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6de09185"]])

export default __exports__